<template>
  <div>

    <!--First 3 blocks-->
      <div :class="['log-entry-container number-container mr-1', highlightNumbersBlock ? 'bg-highlight' : 'bg-darker']">
        <div class="row">
          <log-entry-information-part
              v-for="field in numberFields"
              :key="field"
              :label="field"
              :values="logEntry ? logEntry[field] : '-'"
              :has-border="numberFields.indexOf(field) < numberFields.length - 1"
          />
        </div>
      </div>

      <!--Second 2 blocks-->
      <div v-if="showCreatedBlock" class="log-entry-container bg-secondary">
        <div class="row">
        <log-entry-information-part
            :values="getCreatedAtString(oldestLogEntry)"
            has-border
            label="CreatedBy"
        >
          <user-name-display
              v-if="creatorUserId"
              class="lighter"
              :user-id="creatorUserId"/>
          <span v-else>-</span>
          <br />
        </log-entry-information-part>

        <log-entry-information-part
            :values="getUpdatedAtString(logEntry)"
            label="UpdatedBy"
        >
          <user-name-display
              v-if="updaterUserName"
              class="lighter"
              :user-id="updaterUserName"/>
          <span v-else>-</span>
          <br />
        </log-entry-information-part>
          </div>
      </div>

      <!--total time and total vm time-->
      <div v-if="showTimeBlock" class="log-entry-container bg-darker">
        <div class="row">
          <log-entry-information-part
              label="TotalTime"
              :values="getTotalTime"
              has-border
          />
          <log-entry-information-part
              label="VMTime"
              :values="getVmTime"
          />
        </div>
      </div>

      <!--Last block--->
      <div v-if="showStatusBlock" class="log-entry-container float-right bg-highlight">
        <div class="row">
          <log-entry-information-part
              class="col-12"
              label="Status"
              :values="logEntry ? 'placeholder' : '-'"
          />
        </div>
      </div>
  </div>
</template>

<script>
import DateMixin from "@/components/mixins/DateMixin.js.vue";
import UserNameDisplay from "@/components/UserNameDisplay.vue";
import LogEntryInformationPart from "@/components/pipeline/LogEntryInformationPart.vue";
import vmLogList from "@/components/pipeline/vmLogList";
import vmLogEntry from "@/components/pipeline/vmLogEntry";

export default {
  name: "LogEntryProgress",
  components: {
    UserNameDisplay,
    LogEntryInformationPart
  },
  mixins: [DateMixin],
  props: {
    vmLogEntries: {type: Array, default: () => []},
    showStatusBlock: {type: Boolean, default: true},
    showCreatedBlock: {type: Boolean, default: true},
    showTimeBlock: {type: Boolean, default: true},
    showFinalizedItemsOnly: {type: Boolean, default: true},
    highlightNumbersBlock: {type: Boolean, default: true},
  },
  data() {
    return {
      numberFields: [
        'vertices',
        'geometries',
        'groups',
      ],
    };
  },
  computed: {
    list() {
      return new vmLogList(this.vmLogEntries);
    },
    filteredLogs() {
      if(!this.showFinalizedItemsOnly) {
        return this.list.getItems();
      }
      return this.list.getFinishedImportingItemsOnly();
    },
    logEntry() {
      return this.filteredLogs ? this.filteredLogs[0] : {};
    },
    newestLogEntry() {
      return this.list.getNewestEntry();
    },
    oldestLogEntry() {
      return this.list.getOldestEntry();
    },
    logEntryObject() {
      return new vmLogEntry(this.logEntry);
    },
    updaterUserName() {
      return this.logEntryObject.getCreationUserId();
    },
    creatorUserId() {
      return this.logEntryObject.getCreationUserId();
    },
    getVmTime() {
      const vmTime = this.logEntryObject.getVmTime();
      if(vmTime) {
        return vmTime;
      }
      return 'n/a';
    },
    getTotalTime() {
      return this.logEntryObject.getTotalTime();
    },
    createdAt() {
      return this.logEntryObject.getCreatedAtString();
    },
  },
  methods: {
    getCreatedAtString(le) {
      const logEntry = new vmLogEntry(le);
      return logEntry.getCreatedAtString();
    },
    getUpdatedAtString(le) {
      const logEntry = new vmLogEntry(le);
      return logEntry.getUpdatedAtString();
    },
  }
};
</script>

<style lang="scss" scoped>
.bg-darker {
  background-color: var(--vform-editor-ui-quinary-color);
}
.log-entry-container {
  padding: 7px 15px;
  display: inline-block;
  margin-bottom: 2px;
}

@media (max-width: 1221px) {
  .log-entry-container {
    font-size: 0.8rem;
  }
  .number-container {
    width: 100%;
    margin-bottom: 2px;
    margin-left: 0 !important;
  }
}
@media (max-width: 992px) {
  .number-container {
    width: 100%;
    margin-bottom: 2px;
    margin-left: 0 !important;
  }
  .status-container {
    width: 100%;
    float: none !important;
  }
}
</style>